import React from 'react';
import { Card, CardContent, Box, Typography, Avatar } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import TrendingDownIcon from '@material-ui/icons/TrendingDown';

const useStyles = makeStyles((theme) => ({
  card: {
    height: '100%',
    transition: 'transform 200ms ease, box-shadow 200ms ease',
    '&:hover': { transform: 'translateY(-2px)' },
  },
  top: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  avatar: {
    width: 44,
    height: 44,
    borderRadius: 12,
  },
  value: {
    fontWeight: 800,
    fontSize: '1.95rem',
    letterSpacing: '-0.02em',
    marginTop: theme.spacing(1.5),
    lineHeight: 1.1,
  },
  label: {
    color: theme.palette.text.secondary,
    fontSize: '0.78rem',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    marginTop: 6,
  },
  trend: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    fontWeight: 600,
    fontSize: '0.8rem',
    marginTop: theme.spacing(1),
  },
  trendUp: { color: theme.palette.success.dark },
  trendDown: { color: theme.palette.error.dark },
}));

const StatCard = ({
  icon,
  label,
  value,
  trend,
  trendDirection = 'up',
  gradient = 'linear-gradient(135deg, #6366f1, #4f46e5)',
}) => {
  const classes = useStyles();
  return (
    <Card className={classes.card}>
      <CardContent>
        <Box className={classes.top}>
          <Avatar className={classes.avatar} style={{ background: gradient }}>
            {icon}
          </Avatar>
        </Box>
        <Typography className={classes.value}>{value}</Typography>
        <Typography className={classes.label}>{label}</Typography>
        {trend && (
          <Box
            className={`${classes.trend} ${
              trendDirection === 'up' ? classes.trendUp : classes.trendDown
            }`}
          >
            {trendDirection === 'up' ? (
              <TrendingUpIcon fontSize="small" />
            ) : (
              <TrendingDownIcon fontSize="small" />
            )}
            {trend}
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default StatCard;
